export const SubscriptionMessages = {
    CheckoutFailure: 'Unable to start checkout.',
    PlanChangeScheduled: 'Plan change scheduled. It will take effect at the end of your current billing period.',
    PlanChangeApplied: 'Plan change applied successfully.',
    GenericError: 'Subscription request failed.',
}

export const PLAN_ALERT_CONFIG = {
    "PLAN_EXPIRED": {
        "alertLink": "Subscribe Now",
        "alertText": "Your {{plan_name}} has expired. To continue using uTrade Algos subscribe to a plan."
    },
    "PLAN_AUTORENEWAL": {
        "alertText": "Your {{plan_name}} plan will auto renew {{billing_cycle}}. Kindly maintain sufficient balance."
    },
    "PLAN_VALIDITY": {
        "alertLink": "Subscribe Now",
        "alertText": "Your  {{plan_name}}'s validity will get expired {{billing_cycle}}. To continue using uTrade Algos  subscribe to a plan."
    },
    "PLAN_ZERO": {
        "alertLink": "Subscribe Now",
        "alertText": "Your free plan will expire in {{billing_cycle}}. To maintain access, kindly consider subscribing to a plan. "
    }
}

export enum BILLING_PORTAL_ROUTES {
    Upgrade = 'upgrade',
    ViewPlans = 'plans',
    BillingDashboard = 'dashboard',
    TransactionHistory = 'transactions',
    TopUp = 'topup',
    AlgoSpace = 'algo-spaces',
}

export const CREDITS_EXHAUSTED_DIALOG_CONFIG = {
    "PENDING": {
      "title": "Subscription pending",
      "body": "Your plan is still activating. Credits will apply once your subscription is active. You can also upgrade to a higher plan for more capacity.",
      "show_upgrade": true,
      "show_top_up": true
    },
    "ACTIVE": {
      "title": "Credits exhausted",
      "body": "You've used all credits on your current plan. Upgrade for a higher limit or buy a one-time top-up.",
      "show_upgrade": true,
      "show_top_up": true
    },
    "INACTIVE": {
      "title": "Subscription inactive",
      "body": "Your subscription is not active. Renew or upgrade your plan to continue using this feature and restore your credit limits.",
      "show_upgrade": true,
      "show_top_up": true
    },
    "CANCELLED": {
      "title": "'Upgrade your plan'",
      "body": "Your subscription was cancelled. Choose a plan to upgrade and get back access to premium features and credits.",
      "show_upgrade": true,
      "show_top_up": false
    }
  }